export default {
  markAllAsRead: 'notification/markallasread',
  markAsRead: 'notification/markasread',
  getAll: 'notification/{page}/{pageSize}',
  get: 'notification/{id}'
};
